<template>
  <div id="boardDataForm">
    <div class="common_top_wrap">
      <div class="common_tit">자료실 등록</div>
    </div>
    <div class="common_form_wrap">
      <div class="common_form_item col-6">
        <div class="common_form_label">제목</div>
        <div class="common_form_input">
          <input type="text" v-model="subject" placeholder="제목을 입력하세요"/>
        </div>
      </div>
      <div class="common_form_item col-6">
        <div class="common_form_label">내용</div>
        <div class="common_form_input">
          <editor
              ref="editor"
              :options="editorOptions"
              height="500px"
              initialEditType="wysiwyg"/>
        </div>
      </div>
      <div class="common_form_item col-6 type_file">
        <div class="common_form_label">첨부파일</div>
        <div class="common_form_input type_file">
          <div>
            <div>첨부파일 #1</div>
            <div>
              <template v-if="file1Origin != null && file1Origin.length > 0">{{file1Origin}}</template>
              <template v-else>첨부파일 없음</template>
            </div>
          </div>
          <input type="file" id="file1" ref="file1" @change="uploadFile('file1')"/>
          <label for="file1" class="btn_upload">파일 첨부</label>
          <label class="btn_delete" @click="deleteFile('file1')" v-if="file1Origin != null && file1Origin.length > 0">첨부 삭제</label>
        </div>
        <div class="common_form_input type_file">
          <div>
            <div>첨부파일 #2</div>
            <div>
              <template v-if="file2Origin != null && file2Origin.length > 0">{{file2Origin}}</template>
              <template v-else>첨부파일 없음</template>
            </div>
          </div>
          <input type="file" id="file2" ref="file2" @change="uploadFile('file2')"/>
          <label for="file2" class="btn_upload">파일 첨부</label>
          <label class="btn_delete" @click="deleteFile('file2')" v-if="file2Origin != null && file2Origin.length > 0">첨부 삭제</label>
        </div>
        <div class="common_form_input type_file">
          <div>
            <div>첨부파일 #3</div>
            <div>
              <template v-if="file3Origin != null && file3Origin.length > 0">{{file3Origin}}</template>
              <template v-else>첨부파일 없음</template>
            </div>
          </div>
          <input type="file" id="file3" ref="file3" @change="uploadFile('file3')"/>
          <label for="file3" class="btn_upload">파일 첨부</label>
          <label class="btn_delete" @click="deleteFile('file3')" v-if="file3Origin != null && file3Origin.length > 0">첨부 삭제</label>
        </div>
        <div class="common_form_input type_file">
          <div>
            <div>첨부파일 #4</div>
            <div>
              <template v-if="file4Origin != null && file4Origin.length > 0">{{file4Origin}}</template>
              <template v-else>첨부파일 없음</template>
            </div>
          </div>
          <input type="file" id="file4" ref="file4" @change="uploadFile('file4')"/>
          <label for="file4" class="btn_upload">파일 첨부</label>
          <label class="btn_delete" @click="deleteFile('file4')" v-if="file4Origin != null && file4Origin.length > 0">첨부 삭제</label>
        </div>
        <div class="common_form_input type_file">
          <div>
            <div>첨부파일 #5</div>
            <div>
              <template v-if="file5Origin != null && file5Origin.length > 0">{{file5Origin}}</template>
              <template v-else>첨부파일 없음</template>
            </div>
          </div>
          <input type="file" id="file5" ref="file5" @change="uploadFile('file5')"/>
          <label for="file5" class="btn_upload">파일 첨부</label>
          <label class="btn_delete" @click="deleteFile('file5')" v-if="file5Origin != null && file5Origin.length > 0">첨부 삭제</label>
        </div>
      </div>
    </div>
    <div class="common_bottom_wrap">
      <div class="btn_grey" @click="moveList">목록</div>
      <div class="btn_bottom" @click="saveProgram">{{dataPid != null && dataPid !== '' ? '수정' : '등록'}}</div>
    </div>
  </div>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css'
import { Editor } from '@toast-ui/vue-editor'
import VueDatepickerLocal from 'vue-datepicker-local'
import common from '../../script/common'
import axios from 'axios'
import boardData from '../../script/boardData'

export default {
  components: {editor: Editor, VueDatepickerLocal},
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      // Search
      searchParams: {},
      // Editor
      editorOptions: {},
      // Data
      originData: {},
      dataPid: null,
      subject: '',
      content: '',
      files: '',
      file1Origin: '',
      file1: '',
      file2Origin: '',
      file2: '',
      file3Origin: '',
      file3: '',
      file4Origin: '',
      file4: '',
      file5Origin: '',
      file5: ''
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        if (this.$route.params != null) {
          if (this.$route.params.searchParams != null) {
            this.searchParams = this.$route.params.searchParams
          }
          if (this.$route.params.data != null && this.$route.params.data.dataPid != null) {
            this.setBoardData(this.$route.params.data)
          }
        }
      } else {
        common.amsAlert('general', '세션이 만료되었습니다.\n다시 로그인하세요.')
        this.$router.replace('/Program/List')
      }
    })
  },
  methods: {
    setBoardData (data) {
      console.log(data)
      this.originData = data
      this.dataPid = data.dataPid
      this.subject = data.subject
      if (data.content != null) {
        this.$refs.editor.invoke('setHTML', data.content)
      }
      this.files = data.files
      for (let i = 0; i < this.files.length; i++) {
        this[`file${i + 1}Origin`] = common.getOriginalFileName(this.files[i].fileName)
        this[`file${i + 1}`] = this.files[i].fileName
      }
    },
    uploadFile (type) {
      if (this.$refs[type].files.length !== 1) {
        common.amsAlert('general', '파일을 선택하세요.')
        return
      }
      const file = this.$refs[type].files[0]
      const fileName = file.name
      if (!common.checkValidateLength('max', fileName, 50)) {
        common.amsAlert('general', '파일명은 50자 이내로 설정하세요.')
        return
      }
      if (!common.checkValidateLength('max', file.size, 1048576)) {
        common.amsAlert('general', '크기가 1MB 이하인 파일만 업로드할 수 있습니다.')
        return
      }
      const attachmentTypes = ['file1', 'file2', 'file3', 'file4', 'file5']
      if (attachmentTypes.includes(type)) {
        this[`${type}Origin`] = fileName
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
      let formData = new FormData()
      formData.append('file', file)
      formData.append('path', 'program')
      axios.post('/api/uploadFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        console.log('uploadFile', response)
        if (response.data.resultCode === 1) {
          if (attachmentTypes.includes(type)) {
            this[`${type}`] = response.data.result
          } else {
            common.amsAlert('general', '잘못된 접근입니다.')
          }
        } else {
          common.amsAlert('retry', '파일을 업로드하지 못했습니다.')
        }
      }).catch(response => {
        console.error(response)
        common.amsAlert('retry', '파일을 업로드하지 못했습니다.')
      })
    },
    deleteFile (type) {
      const attachmentTypes = ['file1', 'file2', 'file3', 'file4', 'file5']
      if (attachmentTypes.includes(type)) {
        this[`${type}Origin`] = ''
        this[`${type}`] = ''
      } else {
        common.amsAlert('general', '잘못된 접근입니다.')
      }
    },
    saveProgram () {
      if (!common.checkValidateData('string', this.subject)) {
        common.amsAlert('general', '제목을 입력해주세요.')
        return
      }
      let content = this.$refs.editor.invoke('getHTML')
      if (content == null || content.length <= 0) {
        common.amsAlert('general', '내용을 입력해주세요.')
        return
      }
      let data = {
        subject: this.subject,
        content: content
      }
      let files = []
      if (common.checkValidateData('string', this.file1)) {
        files.push(this.file1)
      }
      if (common.checkValidateData('string', this.file2)) {
        files.push(this.file2)
      }
      if (common.checkValidateData('string', this.file3)) {
        files.push(this.file3)
      }
      if (common.checkValidateData('string', this.file4)) {
        files.push(this.file4)
      }
      if (common.checkValidateData('string', this.file5)) {
        files.push(this.file5)
      }
      if (files.length > 0) {
        data.files = files
      }
      let method = 'put'
      let checkedData = common.checkChangedData(data, this.originData)
      if (this.dataPid != null) {
        method = 'post'
        if (Object.keys(checkedData).length > 0) {
          checkedData.dataPid = this.originData.dataPid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
      }
      console.log(method, checkedData)
      boardData.boardData(method, checkedData, response => {
        console.log('자료실 ' + (method === 'put' ? '등록' : '수정'), response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '자료실을 ' + (method === 'put' ? '등록' : '수정') + '했습니다.')
          this.$router.push({
            name: 'BoardDataList',
            params: {
              from: 'FORM',
              searchParams: this.searchParams
            }
          })
        } else {
          common.amsAlert('retry', '자료실을 ' + (method === 'put' ? '등록' : '수정') + '하지 못했습니다.')
        }
      })
    },
    moveList () {
      this.$router.push({
        name: 'BoardDataList',
        params: {
          searchParams: this.searchParams
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/boardData/Form.vue